import { render } from "./HomeFeedback.vue?vue&type=template&id=02240272"
import script from "./HomeFeedback.vue?vue&type=script&lang=js"
export * from "./HomeFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__